import { render } from "./Agencies.vue?vue&type=template&id=67441934&scoped=true"
import script from "./Agencies.vue?vue&type=script&lang=js"
export * from "./Agencies.vue?vue&type=script&lang=js"

import "./Agencies.vue?vue&type=style&index=0&id=67441934&scoped=true&lang=css"

import exportComponent from "/var/www/html/webmobtuts/realestateapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67441934"]])

export default __exports__